import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {useCart} from '../../../context/CartContext';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner';
import './EntrepriseProducts.css';

const API_URL = import.meta.env.VITE_API_URL;

const EntrepriseProducts = () => {
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedBrand, setSelectedBrand] = useState('');
    const [brands, setBrands] = useState([]);
    const [categories, setCategories] = useState([]);
    const {addToCart} = useCart();

    useEffect(() => {
        fetchInitialData();
    }, []);

    const fetchInitialData = async () => {
        try {
            setLoading(true);
            const [productsRes, brandsRes, categoriesRes] = await Promise.all([
                axios.get(`${API_URL}/produits`),
                axios.get(`${API_URL}/partners`),
                axios.get(`${API_URL}/types-produit`)
            ]);

            const pData = productsRes.data.data || productsRes.data || [];
            const bData = brandsRes.data.data || brandsRes.data || [];
            const cData = categoriesRes.data.data || categoriesRes.data || [];

            setProducts(pData);
            setFilteredProducts(pData);
            setBrands(bData);
            setCategories(cData);
        } catch (error) {
            console.error('Erreur data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const results = products.filter(product => {
            const matchesSearch = product.nomProduit?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                product.description?.toLowerCase().includes(searchTerm.toLowerCase());
            const matchesCategory = selectedCategory === '' || product.typeProduit?._id === selectedCategory;
            const matchesBrand = selectedBrand === '' || product.marque?._id === selectedBrand;

            return matchesSearch && matchesCategory && matchesBrand;
        });
        setFilteredProducts(results);
    }, [searchTerm, selectedCategory, selectedBrand, products]);

    return (
        <div className="entreprise-products-container">
            <div className="ent-section-header">
                <h2>Catalogue Produits B2B</h2>
                <p>Achetez vos équipements solaires directement en ligne avec votre tarif préférentiel.</p>
            </div>

            <div className="filter-bar">
                <div className="search-box">
                    <span className="search-icon">🔍</span>
                    <input
                        type="text"
                        placeholder="Rechercher un produit..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <div className="filter-selects">
                    <select
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                    >
                        <option value="">Toutes les catégories</option>
                        {categories.map(cat => (
                            <option key={cat._id} value={cat._id}>{cat.label}</option>
                        ))}
                    </select>
                    <select
                        value={selectedBrand}
                        onChange={(e) => setSelectedBrand(e.target.value)}
                    >
                        <option value="">Toutes les marques</option>
                        {brands.map(brand => (
                            <option key={brand._id} value={brand._id}>{brand.name}</option>
                        ))}
                    </select>
                </div>
            </div>

            {loading ? (
                <LoadingSpinner message="Chargement du catalogue..." />
            ) : filteredProducts.length === 0 ? (
                <div className="empty-state">
                    <span>📦</span>
                    <h3>Aucun produit trouvé</h3>
                    <p>Réessayez avec d'autres filtres de recherche.</p>
                </div>
            ) : (
                <div className="products-grid">
                    {filteredProducts.map((product) => (
                        <div key={product._id} className="product-card">
                            <div className="product-image">
                                <img
                                    src={product.imageProduit ? `${API_URL.replace('/api', '')}${product.imageProduit}` : 'https://via.placeholder.com/300x200?text=Produit+Solaire'}
                                    alt={product.nomProduit}
                                />
                                <div className="product-category">{product.typeProduit?.label}</div>
                            </div>
                            <div className="product-info">
                                <div className="product-brand">{product.marque?.name}</div>
                                <h3>{product.nomProduit}</h3>
                                <p className="product-desc">
                                    {product.description?.substring(0, 100)}
                                    {product.description?.length > 100 ? '...' : ''}
                                </p>
                                <div className="product-bottom">
                                    <div className="product-price">
                                        <span className="price-val">{product.prix?.toLocaleString()} DT</span>
                                        <span className="price-tva">+19% TVA</span>
                                    </div>
                                    <button
                                        className="add-to-cart-btn"
                                        onClick={() => {
                                            const item = {
                                                _id: product._id,
                                                nom: product.nomProduit,
                                                prix: product.prix,
                                                image: product.imageProduit,
                                                marque: product.marque?.name
                                            };
                                            addToCart(item);
                                        }}
                                    >
                                        🛒 Ajouter
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default EntrepriseProducts;
